import React from 'react';

interface AdminLayoutProps {
  title: string;
  subtitle: string;
  onLogout: () => void;
  children: React.ReactNode;
}

const Layout: React.FC<AdminLayoutProps> = ({ title, subtitle, onLogout, children }) => {

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={onLogout}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 text-sm font-medium"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-8">
        {children}
      </main>
    </div>
  );
};

export default Layout;
